import React from "react";
import { Grid } from "@mui/material";
import {
  ControlledCustomSelect,
  CustomFormLabel,
  CustomTextField,
} from "../../../../../../../components/formsComponents";
import { CustomDatePicker } from "../../../../../../../components/formsComponents/CustomDatePicker";
import { IHabitationalPolicyChangeProps } from "./HabitationalPolicyChange.types";
import { LabelCard } from "../../../../../../../components/LabelCard/LabelCard";

export const NameChangeInformation: React.FC<
  IHabitationalPolicyChangeProps
> = ({ values, setValues, errors, handleChange, setFieldValue }) => {
  return (
    <>
      <LabelCard heading=" Name Change" />
      <Grid container spacing={1}>
        <Grid item xs={12} md={4}>
          <CustomFormLabel>New Name</CustomFormLabel>
          <CustomTextField
            name="name_change.new_name"
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            value={values.name_change.new_name}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <CustomFormLabel>Date of Birth</CustomFormLabel>
          <CustomDatePicker
            fullWidth
            value={values.name_change.date_of_birth || ""}
            onChange={(newDate: string) => {
              setFieldValue("name_change.date_of_birth", newDate);
            }}
            errorMessage={errors.name_change?.date_of_birth as string}
            // In the V2 policy-change flow this picker is rendered inside a
            // right-side drawer (zIndex 1400). Its calendar popup portals to the
            // body at the default modal zIndex (1300) and would open *behind*
            // the drawer. Keep it above the drawer.
            popupZIndex={1600}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <CustomFormLabel>Relationship</CustomFormLabel>
          <ControlledCustomSelect
            variant="outlined"
            size="small"
            type="string"
            fullWidth
            displayEmpty
            name="name_change.relationship"
            value={values.name_change.relationship}
            onChange={handleChange}
            placeholder="Select One"
            helperText={errors.name_change?.relationship as string}
            // In the V2 policy-change flow this select is rendered inside a
            // right-side drawer (zIndex 1400). Its dropdown menu portals to the
            // body at the default modal zIndex (1300), so without this it opens
            // *behind* the drawer and looks empty. Keep the menu above 1400.
            MenuProps={{ sx: { zIndex: 1600 } }}
            options={[
              { label: "Spouse", value: "Spouse" },
              { label: "Child", value: "Child" },
              { label: "Parent", value: "Parent" },
              { label: "Business Partner", value: "Business Partner" },
              { label: "Other", value: "Other" },
            ]}
          />
        </Grid>
      </Grid>
    </>
  );
};
